

<script>
  import { onMount } from 'svelte';

  let deliveries = [];
  let numberOfDeliveries = 0;
  let loading = true;
  let error = null;

  onMount(async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await fetch('https://groupfruits.online/shop/api/PickupCodesView/', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      deliveries = data.deliveries;
      numberOfDeliveries = data.number_of_deliveries;
      loading = false;
    } catch (err) {
      error = err.message;
      loading = false;
    }
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  }

  function handleBackClick() {
    // Dispatch a custom event to navigate back
    dispatch('navigate', { to: 'previous' });
  }
</script>

<div class="today-pickups">
  <header>
    <button class="back-button" on:click={handleBackClick}>&lt;</button>
    <h1>Today Pickup's ({numberOfDeliveries})</h1>
  </header>

  {#if loading}
    <p>Loading...</p>
  {:else if error}
    <p class="error">{error}</p>
  {:else}
    {#each deliveries as delivery (delivery.pickup_code)}
      <div class="pickup-card">
        <h2>Pickup Code ({delivery.category_title})</h2>
        <div class="pickup-code">
          <span>{delivery.pickup_code}</span>
          <p>{formatDate(delivery.delivery_date)}: {delivery.delivery_message || 'Collect Now'}</p>
        </div>
        <p class="pickup-point">Pickup point: {delivery.delivery_point_address}</p>
        <p class="order-amount">
          Order amount: ₹{delivery.order_total_price} 
          ({delivery.order_payment_status === 'successful' ? 'PAID' : 'CASH'})
        </p>
      </div>
    {/each}
  {/if}
</div>

<style>
  .today-pickups {
    font-family: Arial, sans-serif;
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
  }

  header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .back-button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 0 10px;
  }

  h1 {
    margin: 0;
    font-size: 20px;
  }

  .pickup-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  h2 {
    font-size: 16px;
    margin: 0 0 10px 0;
    color: #333;
  }

  .pickup-code {
    background-color: #4833DA;
    color: white;
    border-radius: 8px;
    padding: 15px;
    text-align: center;
    margin-bottom: 15px;
  }

  .pickup-code span {
    font-size: 36px;
    font-weight: bold;
    display: block;
    margin-bottom: 5px;
  }

  .pickup-code p {
    margin: 0;
    font-size: 14px;
  }

  .pickup-point, .order-amount {
    font-size: 14px;
    margin: 5px 0;
  }

  .error {
    color: red;
  }
</style>
